import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { resources } from "../../Resourses/Resources";

const successMessage = (message) => {
  toast.success(message, {
    position: "top-center",
    toastId: "success1",
    className: "success",
  });
};

const errorMessage = (message) => {
  toast.error(message, {
    position: "top-center",
    toastId: "error1",
    className: "error",
  });
};

const StudentForm = () => {
  const initialState = {
    studentId: "",
    nameOfTheStudent: "",
    studentGender: "",
    studentPrimaryEmailAddress: "",
    studentAdharNumber: "",
    sudentContact: "",
    studentInstituteState: "",
    studentAictePerminentId: "",
    studentInstituteName: "",
    studentInstituteAddress: "",
  };

  const [isLoading, setIsLoading] = useState(false);
  const [aicteStudent, setAicteStudent] = useState(initialState);

  const handleAicteStudentDetails = (e) => {
    const { value, name } = e.target;
    setAicteStudent({ ...aicteStudent, [name]: value });
  };

 
  const validateForm = () => {
    const requiredFields = [
      "studentId",
      "nameOfTheStudent",
      "studentGender",
      "studentPrimaryEmailAddress",
      "sudentContact",
      "studentInstituteState",
      "studentAictePerminentId",
      "studentInstituteName",
      "studentInstituteAddress",
    ];

    for (let field of requiredFields) {
      if (!aicteStudent[field]) {
        errorMessage(`Please fill out all required fields.`);
        return false;
      }
    }
    return true;
  };

  const handleSubmitDataToBackend = async () => {
    if (!validateForm()) return; 

    console.log("Submitting Data:", JSON.stringify(aicteStudent));

    try {
      setIsLoading(true);
      const res = await axios.post(
        resources.APPLICATION_URL + "saveAicteStudentFeedBackDetails",
        aicteStudent
      );

      console.log("Response from API:", res);

      if (res.status === 200 || res.status === 201) {
        successMessage("Data Submitted Successfully");
        setAicteStudent(initialState); // Reset form fields
      } else {
        errorMessage("Submission failed, please try again.");
      }
    } catch (e) {
      console.log("Error:", e);
      errorMessage("Error submitting data.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <h1 className="student_faculty_form_heading">Student Form</h1>
      <form className="student_faculty_form_main_container">
        <div className="student_faculty_form_sub_container">
          <div className="student_faculty_form_container">
            <label htmlFor="studentId">Student Id:</label>
            <input
              onChange={handleAicteStudentDetails}
              value={aicteStudent.studentId}
              type="text"
              placeholder="Student Id"
              id="studentId"
              name="studentId"
              required
            />
          </div>
          <div className="student_faculty_form_container">
            <label htmlFor="nameOfTheStudent">Name Of The Student:</label>
            <input
              onChange={handleAicteStudentDetails}
              value={aicteStudent.nameOfTheStudent}
              type="text"
              name="nameOfTheStudent"
              placeholder="Name Of The Student"
              id="nameOfTheStudent"
              required
            />
          </div>
          <div className="student_faculty_form_container">
            <label>Gender</label>
            <div style={{ display: "flex" }}>
              <span className="span_ele">Male</span>
              <input
                type="radio"
                value="male"
                id="male"
                name="studentGender"
                checked={aicteStudent.studentGender === "male"}
                onChange={handleAicteStudentDetails}
              />
              <span className="span_ele">Female</span>
              <input
                type="radio"
                value="female"
                id="female"
                name="studentGender"
                checked={aicteStudent.studentGender === "female"}
                onChange={handleAicteStudentDetails}
              />
              <span className="span_ele">Other</span>
              <input
                type="radio"
                value="other"
                id="other"
                name="studentGender"
                checked={aicteStudent.studentGender === "other"}
                onChange={handleAicteStudentDetails}
              />
            </div>
          </div>
          <div className="student_faculty_form_container">
            <label htmlFor="studentPrimaryEmailAddress">Primary Email Address:</label>
            <input
              onChange={handleAicteStudentDetails}
              value={aicteStudent.studentPrimaryEmailAddress}
              type="email"
              placeholder="Email"
              id="studentPrimaryEmailAddress"
              name="studentPrimaryEmailAddress"
              required
            />
          </div>
          <div className="student_faculty_form_container">
            <label htmlFor="sudentContact">Contact:</label>
            <input
              onChange={handleAicteStudentDetails}
              value={aicteStudent.sudentContact}
              type="number"
              placeholder="Contact"
              id="sudentContact"
              name="sudentContact"
              required
            />
          </div>
          <div className="student_faculty_form_container">
            <label htmlFor="studentInstituteState">Institute State:</label>
            <input
              onChange={handleAicteStudentDetails}
              value={aicteStudent.studentInstituteState}
              name="studentInstituteState"
              type="text"
              placeholder="Institute State"
              id="studentInstituteState"
              required
            />
          </div>
        </div>
      </form>

      <form className="student_faculty_form_main_container">
        <div className="student_faculty_form_sub_container">
          <div className="student_faculty_form_container">
            <label htmlFor="studentAictePerminentId">AICTE Permanent Id:</label>
            <textarea
              onChange={handleAicteStudentDetails}
              value={aicteStudent.studentAictePerminentId}
              name="studentAictePerminentId"
              cols={40}
              rows={5}
              placeholder="AICTE Permanent Id"
              id="studentAictePerminentId"
              required
            />
          </div>
          <div className="student_faculty_form_container">
            <label htmlFor="studentInstituteName">Institute Name:</label>
            <textarea
              onChange={handleAicteStudentDetails}
              value={aicteStudent.studentInstituteName}
              name="studentInstituteName"
              cols={40}
              rows={5}
              placeholder="Institute Name"
              id="studentInstituteName"
              required
            />
          </div>
          <div className="student_faculty_form_container">
            <label htmlFor="studentInstituteAddress">Institute Address:</label>
            <textarea
              onChange={handleAicteStudentDetails}
              value={aicteStudent.studentInstituteAddress}
              name="studentInstituteAddress"
              cols={40}
              rows={5}
              placeholder="Institute Address"
              id="studentInstituteAddress"
            />
          </div>
        </div>
      </form>
      <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
        <button
          onClick={handleSubmitDataToBackend}
          type="button"
          className="aicte_submit_btn"
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default StudentForm;
